import { jsx } from "react/jsx-runtime";
function BlankPage({ pageWidth, pageHeight }) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: "print-page",
      style: {
        position: "relative",
        overflow: "hidden",
        boxSizing: "border-box",
        width: pageWidth,
        height: pageHeight,
        background: "#ffffff"
      }
    }
  );
}
export {
  BlankPage
};
//# sourceMappingURL=BlankPage.js.map
